import type {
  PropertyHeroData,
  GalleryImage,
  PropertyStoryData,
  SignatureFeature,
  EssentialInfoGroup,
  PropertyReview,
  PropertyConciergeConfig,
  PropertyInquiryData,
  StickyBookBarData,
} from '../types';

export const heroData: PropertyHeroData = {
  id: 'sea-dreams',
  name: 'Sea Dreams',
  location: 'Thomas Drive',
  area: 'Panama City Beach',
  bedrooms: '5',
  bathrooms: '5',
  sleeps: 'Up to 16',
  heroImage: 'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-60.jpg',
  matterportUrl: 'https://my.matterport.com/show/?m=AMuYV6FoNyr&mls=1',
};

const orderedGalleryUrls = [
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-60.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-46.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-59.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-57.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-14.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-15.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-17.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-18.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-26.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-25.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-27.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-21.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-20.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-22.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-23.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-32.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-24.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-54.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-43.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-42.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-34.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-35.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-44.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-53.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-28.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-29.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-37.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-38.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-36.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-31.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-39.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-40.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-33.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-51.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-52.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-41.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-45.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-30.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-47.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-48.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-49.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-58.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-50.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-55.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-56.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-16.jpg',
  'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-61.jpg',
];

export const galleryImages: GalleryImage[] = orderedGalleryUrls.map((src, index) => ({
  src,
  alt: `Sea Dreams photo ${index + 1}`,
  caption: `Photo ${index + 1} of ${orderedGalleryUrls.length}`,
}));

export const storyData: PropertyStoryData = {
  subheading: 'With a private pool out back and Gulf views from all three levels, your camera roll may need extra room.',
  paragraphs: [
    "Sea Dreams is a newly renovated, three-level beachfront home in the Thomas Drive area of Panama City Beach. With five bedrooms, five bathrooms, and room for up to 16 guests, it was built for a family that wants to be as close to the water as possible without giving up any of the comforts of home.",
    "Step inside and you\u2019re greeted with a spacious living room \u2014 flat-screen TV, DVD player, Xbox, and a queen-size sofa sleeper, the perfect landing spot after a long day at the beach. The fully equipped kitchen has stainless steel appliances, granite countertops, and a dining table that seats 8, with additional seating at the breakfast bar.",
    "The second floor holds two guest bedrooms and the primary suite. The primary bedroom is at the end of the hallway with a king bed, a large flat-screen TV, and a private bathroom with a jetted tub and walk-in shower. Its balcony looks straight out at the Gulf. On the third floor, the fourth guest bedroom features a queen bed, two twin beds, a flat screen, a mini refrigerator and wet bar, and a private balcony with even more incredible Gulf views.",
    "Outside, the private beachfront pool is steps from the sand. Lounge chairs surround it, and the outdoor space includes a dining area with views of the beach. A gas grill and an extra refrigerator in the garage make it easy to stay in when you feel like it. The beach itself is accessible directly from the property.",
    "For families traveling with young children, a pack-and-play and high chair are provided. A washer and dryer are available, and Wi-Fi is complimentary throughout. If you\u2019re visiting for a sporting event, Sea Dreams sits close to the Publix Sports Complex and Frank Brown Park. Pier Park, with over 120 restaurants, shops, and entertainment venues, is 5 miles away.",
  ],
  locationContext:
    "Sea Dreams is on Thomas Drive in Panama City Beach, right on the Gulf. Restaurants, bars, and shopping are within walking distance. Pier Park is 5 miles away, featuring over 120 restaurants, shops, and the Grand 16 IMAX Theater.",
  address: 'Thomas Drive',
  addressSub: 'Panama City Beach, Florida',
  propertyMeta: '5 bedrooms \u00b7 5 bathrooms \u00b7 3 levels \u00b7 Beachfront',
};

export const signatureFeatures: SignatureFeature[] = [
  {
    title: 'Private Beachfront Pool',
    body: 'Steps from the sand, the private pool is the centerpiece of the outdoor living space. Lounge chairs line the surround, with a dining area close by for evenings outside. Heated for an additional fee. When you\u2019re done in the pool, the beach is right there.',
    image: 'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-57.jpg',
    imageAlt: 'Sea Dreams beachfront pool',
    tag: 'Gulf front',
  },
  {
    title: 'Gulf Views from Every Level',
    body: "Sea Dreams is three stories, and the Gulf is visible from all of them. The primary suite balcony, the third-floor bedroom\u2019s private terrace, and the common areas below all look straight out at the water. In the morning it\u2019s the sunrise over the Gulf. In the evening, it\u2019s one of the best sunset views on Thomas Drive.",
    image: 'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-46.jpg',
    imageAlt: 'Sea Dreams Gulf view',
    tag: 'Gulf views \u00b7 All 3 levels',
  },
  {
    title: 'Room for Everyone',
    body: "Five bedrooms spanning three floors accommodate up to 16 guests comfortably. Every bedroom has its own television and its own bathroom. The living room has a queen sleeper sofa. The layout gives each part of your group its own space while keeping everyone together when you want to be.",
    image: 'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-14.jpg',
    imageAlt: 'Sea Dreams interior living and kitchen',
    tag: 'Sleeps up to 16',
  },
  {
    title: 'The Kitchen',
    body: "Stainless steel appliances, granite countertops, and a dining table that seats eight. A breakfast bar with additional seating. A gas grill outside and an extra refrigerator in the garage for overflow. Whether you\u2019re planning a big family dinner or just making breakfast before a beach day, the kitchen is fully set up for it.",
    image: 'https://inspirevp.com/wp-content/uploads/2021/10/sea-dreams-14.jpg',
    imageAlt: 'Sea Dreams kitchen',
    tag: 'Fully equipped',
  },
];

export const essentialInfoGroups: EssentialInfoGroup[] = [
  {
    heading: 'At a glance',
    items: [
      '5 bedrooms',
      '5 bathrooms',
      'Sleeps up to 16 guests',
      '3 levels \u00b7 Beachfront',
      'Thomas Drive area \u2014 Panama City Beach',
      'Newly renovated with all-new furnishings & mattresses',
    ],
  },
  {
    heading: 'Key features',
    items: [
      'Gulf front private pool (heated for additional fee)',
      'Beachfront \u2014 direct beach access steps from the pool',
      'Expansive Gulf views from all three levels',
      'Gas grill & extra refrigerator in garage',
      'Parking for up to 3 vehicles (depending on type & size)',
    ],
  },
  {
    heading: 'The kitchen',
    items: [
      'Stainless steel appliances',
      'Granite countertops',
      'Dining table seats 8',
      'Breakfast bar seating',
      'Gas grill outside',
      'Extra refrigerator in garage',
      'Complimentary Wi-Fi',
    ],
  },
  {
    heading: 'The bedrooms',
    items: [
      'Level 1 guest bedroom \u2014 king bed, flat-screen TV, full bath',
      'Level 2 guest bedroom \u2014 queen bed, flat-screen TV, full bath',
      'Level 2 guest bedroom \u2014 2 queen beds, flat-screen TV, full bath',
      'Primary suite (Level 2) \u2014 king bed, flat-screen TV, jetted tub & walk-in shower, Gulf balcony',
      'Level 3 guest bedroom \u2014 queen + 2 twin beds, flat-screen TV, mini fridge & wet bar, private Gulf balcony',
    ],
  },
  {
    heading: 'Family features',
    items: [
      'Pack-and-play provided',
      'High chair provided',
      'Xbox & board games',
      'Washer & dryer',
      'Complimentary Wi-Fi',
    ],
  },
  {
    heading: 'The area',
    items: [
      'Steps to the beach from the pool',
      'Pier Park 5 miles \u2014 120+ restaurants, shops & IMAX',
      'Publix Sports Complex & Frank Brown Park nearby',
      'Restaurants, bars, and shopping within walking distance',
    ],
  },
];

export const reviews: PropertyReview[] = [
  {
    id: 'sd-r1',
    title: 'Best place I have stayed in Florida. Very clean',
    body: "The house is so nice and very clean. It is big on the inside, there is tons of room and each bedroom has a bathroom. The outside is nice and it is right on the beach. We went in October, the beach felt so private in this area. The kitchen had everything we needed. They even leave little things of shampoo/conditioner. There was toilet paper, bath towels. I have stayed several places in Florida and this was the cleanest/nicest place I have stayed.",
    author: 'Destiny J.',
    date: 'Oct 2025',
    stars: 5,
  },
  {
    id: 'sd-r2',
    title: 'The view was absolutely stunning',
    body: "The view was amazing. The heated pool was very nice at night time. The kitchen was very well equipped and stocked. The bedrooms upstairs had beautiful views also. Very spacious. The house was very clean and bathrooms were stocked with plenty of towels. The washer and dryer was a big hit and worked great. We had a problem with one of the toilets, and they had a plumber there within 30 minutes to get it fixed. Sea Dreams is everything it was advertised as.",
    author: 'Telina T.',
    date: 'Oct 2025',
    stars: 5,
  },
  {
    id: 'sd-r3',
    title: 'The BEST family vacation!',
    body: "Sea Dreams was exactly the perfect place to spend our family spring break vacation. Being right on the beach and having a heated pool gave everyone an opportunity to do what they wanted. There were plenty of comfortable beds, bathrooms and balconies to accommodate our family of 12. This beach home was well equipped! Loved the patio furniture! Sand on the beach is soft as snow. The sunsets are gorgeous. We saw lots of dolphins and collected unique sea shells.",
    author: 'Tom/Kathy G.',
    date: 'Mar 2024',
    stars: 5,
  },
  {
    id: 'sd-r4',
    title: 'Great place to stay!',
    body: "We enjoyed our stay at Sea Dreams this past week. Very clean and lots of room for my family of 13. Bedrooms are large and everyone having their own bathroom is nice. Kitchen was fully stocked. We enjoyed having the pool right out the back door. Access to the beach is just down a few steps which was good for my parents. Andy was very easy to work with. We would stay again.",
    author: 'Leecy S.',
    date: 'Aug 2023',
    stars: 5,
  },
  {
    id: 'sd-r5',
    title: 'Great house in the perfect spot',
    body: "This house was everything we were looking for in a beach house. The pool was perfect, it\u2019s right on the beach, and the house was clean and comfortable. Thanks for a great stay!",
    author: 'John W.',
    date: 'May 2023',
    stars: 5,
  },
  {
    id: 'sd-r6',
    title: 'Memories made at Sea Dreams',
    body: "This house had everything we needed and more. Direct beach access, beautiful views, plenty of room, and a great outdoor space. The kitchen was fully stocked with everything we needed. We appreciated having the extra refrigerator in the garage for additional space, and we enjoyed having the gas grill to cook dinner on a couple of nights. Andy with Inspire was super responsive both before our trip and during. We hope to be back again to Sea Dreams and I would definitely book through Inspire again.",
    author: 'Karen H.',
    date: 'Jun 2022',
    stars: 5,
  },
  {
    id: 'sd-r7',
    title: 'The stay was very nice and relaxing',
    body: "Sea Dreams is a wonderful place to stay. It had plenty of room for 4 families. The pool was awesome with lots of chairs for relaxing in shade or sun. The saltwater pool was amazing and very clean. The walk down to beach was just seconds away from pool area. I would definitely go back! Very nice amenities from kitchen appliances and cookware to washer and dryer and also very hot water for showers.",
    author: 'Apryl H.',
    date: 'May 2022',
    stars: 5,
  },
];

export const conciergeConfig: PropertyConciergeConfig = {
  propertyId: 'sea-dreams',
  propertyName: 'Sea Dreams',
  introText:
    "Hello \u2014 I\u2019m here to help you get to know Sea Dreams. Ask me anything about the property: the beachfront pool, the Gulf views, room for your group, or anything else you\u2019d like to know.",
  seedQuestion: 'Is it really right on the beach?',
  starters: [
    'How many guests does it sleep?',
    'Tell me about the pool.',
    'Are there Gulf views?',
    'What\u2019s the beach access like?',
    'Does it work for large groups?',
    'Does it allow pets?',
    'What\u2019s nearby?',
  ],
};

export const inquiryData: PropertyInquiryData = {
  propertyName: 'Sea Dreams',
  propertyLocation: 'Thomas Drive, Panama City Beach',
  sleeps: '16',
};

export const stickyBarData: StickyBookBarData = {
  propertyId: 'sea-dreams',
  propertyName: 'Sea Dreams',
  location: 'Thomas Drive \u00b7 Panama City Beach',
  bedrooms: '5 bed',
  sleeps: 'Sleeps 16',
};

export const bayCountyCertificateId = '28158';
